import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagsEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tags-edit" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.879,19.188,1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.189,
			y1: 4.124,
			x2: 16.189,
			y2: 4.124
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.32,14.868,14.689,22.5l-3.75.75.75-3.75,7.631-7.631a2.115,2.115,0,0,1,2.991,0l.009.009A2.115,2.115,0,0,1,22.32,14.868Z"
		})
	]
});
export default SvgTagsEdit;
